export default __webpack_public_path__ + "static/media/15.128c8b9a.png";